/**
 * Google Analytics 4 utility for Belong app.
 * Tracks page views, user engagement, and custom events.
 * 
 * Setup: Set REACT_APP_GA_MEASUREMENT_ID in your .env file
 * e.g. REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX
 */

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function isEnabled() {
  return GA_ID && typeof window.gtag === 'function';
}

/**
 * Track a page view — called automatically on every route change.
 */
export function trackPageView(path, title) {
  if (!isEnabled()) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.origin + path,
  });
}

/**
 * Track custom events (button clicks, feature usage, etc.)
 * 
 * Examples:
 *   trackEvent('sign_up', { method: 'email' })
 *   trackEvent('connection_request', { target_identity: 'deaf' })
 *   trackEvent('group_joined', { group_type: 'city' })
 */
export function trackEvent(eventName, params = {}) {
  if (!isEnabled()) return;
  window.gtag('event', eventName, params);
}

/**
 * Set user properties for segmentation in GA4 reports.
 * Call after login/registration.
 * 
 * Example:
 *   setUserProperties({ city: 'Austin', account_type: 'verified' })
 */
export function setUserProperties(properties) {
  if (!isEnabled()) return;
  window.gtag('set', 'user_properties', properties);
}

/**
 * Set the GA user ID (use your app's user ID, not PII).
 * Call after login.
 */
export function setUserId(userId) {
  if (!isEnabled()) return;
  window.gtag('config', GA_ID, { user_id: userId });
}
